import script from "./TotpQrCode.vue?vue&type=script&setup=true&lang=js"
export * from "./TotpQrCode.vue?vue&type=script&setup=true&lang=js"

import "./TotpQrCode.vue?vue&type=style&index=0&id=06a80858&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06a80858"]])

export default __exports__